import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Color } from "../cutoff/Cutoff";

/**
 * # PredictionRecord
 * 
 * PredictionRecord을 설명하세요.
 */
export const PredictionRecord = types
  .model("PredictionRecord")
  // --------------------------------------------------------------------------
  .props({
    patientId: types.maybeNull(types.optional(types.number, 0)),
    date: types.maybeNull(types.optional(types.string, "")),
    predictionRate: types.maybeNull(types.optional(types.number, 0)),
    color : types.maybeNull(types.optional(Color, {})),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model predictionRecord --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IPredictionRecord;
      (Object.keys(newProps) as TPredictionRecordKeys[]).forEach((key) => {
        //@ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TPredictionRecord = Instance<typeof PredictionRecord>;
type TPredictionRecordSnapshot = SnapshotOut<typeof PredictionRecord>

export interface IPredictionRecord extends TPredictionRecord {}
export type TPredictionRecordKeys = keyof TPredictionRecordSnapshot & string;
export interface IPredictionRecordSnapshot extends TPredictionRecordSnapshot {}
export const createPredictionRecord = () => 
  types.optional(PredictionRecord, {
  } as TPredictionRecord);
